import React from 'react';

import { bfiLogo } from 'app/assets/svgs';
import BackButton from 'app/SharedComponents/BackButton';

interface HeaderProps {
  backURL?: string;
}

const Header = ({ backURL = '' }: HeaderProps) => (
  <header className="px-6 py-4" data-testid="header-component">
    <div className="flex justify-center relative">
      {backURL && <BackButton url={backURL} />}
      <div>
        <a href="/" className="self-center">
          <img src={bfiLogo} alt="BFI Logo" height="100%" width="100%" />
        </a>
      </div>
    </div>
  </header>
);

export default Header;
